enum DateType {
  PICK_UP = 'pickup',
  DELIVERY = 'delivery',
}

export { DateType };
